import {
  fetchNavigationTree,
  saveNavigationTree,
  createCategory,
  updateCategory,
  deleteCategory,
  deleteLabel,
  deleteSubCategory,
  updateCategoryPriorities,
} from 'src/api/navigationManagerApi';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

export const NavigationManagerActionTypes = {
  GET_NAVIGATION_TREE_SUCCESS: '[API] : [NAVIGATION MANAGER] : Get navigation tree.',
  SAVE_NAVIGATION_TREE_SUCCESS: '[API] : [NAVIGATION MANAGER] : Save navigation tree.',
};

export function GetNavigationTreeAction(metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());

      const response = await fetchNavigationTree();

      dispatch({
        type: NavigationManagerActionTypes.GET_NAVIGATION_TREE_SUCCESS,
        payload: { data: response.data.data || [] },
      });
      dispatch(ApiCallSuccessAction(handleApiSuccess(null)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function SaveNavigationTreeAction(payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());

      const response = await saveNavigationTree(payload);

      dispatch({
        type: NavigationManagerActionTypes.SAVE_NAVIGATION_TREE_SUCCESS,
        payload: { data: response.data.data || [] },
      });
      dispatch(ApiCallSuccessAction({ message: 'Navigation menu saved successfully.' }));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function CreateNavigationCategoryAction(categoryNode, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      await createCategory(categoryNode);
      dispatch(ApiCallSuccessAction({ message: 'Category created successfully.' }));
      dispatch(GetNavigationTreeAction());
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateNavigationCategoryAction(categoryNode, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      await updateCategory(categoryNode);
      dispatch(ApiCallSuccessAction({ message: 'Category updated successfully.' }));
      dispatch(GetNavigationTreeAction());
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function DeleteNavigationCategoryAction(categoryId, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      await deleteCategory(categoryId);
      dispatch(ApiCallSuccessAction({ message: 'Category deleted successfully.' }));
      dispatch(GetNavigationTreeAction());
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function DeleteNavigationLabelAction(labelId, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      await deleteLabel(labelId);
      dispatch(ApiCallSuccessAction({ message: 'Label deleted successfully.' }));
      dispatch(GetNavigationTreeAction());
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function DeleteNavigationSubCategoryAction(subCategoryId, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      await deleteSubCategory(subCategoryId);
      dispatch(ApiCallSuccessAction({ message: 'Subcategory deleted successfully.' }));
      dispatch(GetNavigationTreeAction());
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateNavigationCategoryPrioritiesAction(prioritiesPayload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      await updateCategoryPriorities(prioritiesPayload);
      dispatch(ApiCallSuccessAction({ message: 'Category priorities updated successfully.' }));
      dispatch(GetNavigationTreeAction());
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
